import {useIntl} from 'react-intl'
import {Table} from 'src/feature/bite/component/Table'
import {getDateAndTime} from 'src/feature/bite/helpers/date'
import {useStore} from 'src/feature/store/hook'

const StoreSubscriptions = ({loading}: {loading: boolean}) => {
  const intl = useIntl()
  const {detail, detailSet, tabFilter, tabFilterSet} = useStore()

  const data = detail?.Subscription?.dataList || []
  const paging = detail?.Subscription?.paging || {
    currentPageNumber: 0,
    totalPagesNumber: 0,
    pageSize: 0,
    totalCount: 0,
  }

  const Columns = [
    {
      key: 'Type',
      dataIndex: 'typeName',
      title: intl.formatMessage({id: 'STORE.DETAIL.SUBSCRIPTIONS.TYPE'}),
    },
    {
      key: 'Price',
      dataIndex: 'price',
      title: intl.formatMessage({id: 'STORE.DETAIL.SUBSCRIPTIONS.PRICE'}) + ' ($)',
      monetize: true,
    },
    {
      key: 'status',
      dataIndex: 'statusID',
      title: intl.formatMessage({id: 'STORE.DETAIL.SUBSCRIPTIONS.STATUS'}),
      status: true,
    },
    {
      key: 'customerPackage',
      dataIndex: 'customerPackage',
      title: intl.formatMessage({id: 'STORE.DETAIL.SUBSCRIPTIONS.CUSTOMER_PACKAGE'}),
    },
    // {
    //   key: 'PaidAmount', dataIndex: 'paidAmount',
    //   title: intl.formatMessage({ id: 'STORE.DETAIL.SUBSCRIPTIONS.PAID_AMOUNT' }),
    //   render: (text: any) => <>{text.toFixed(2)}</>
    // },
    {
      key: 'ActivationDate',
      dataIndex: 'activationDate',
      title: intl.formatMessage({id: 'STORE.DETAIL.SUBSCRIPTIONS.ACTIVATION_DATE'}),
      render: (text: string) => <>{getDateAndTime(text)}</>,
    },
    {
      key: 'ExpiryDate',
      dataIndex: 'expiryDate',
      title: intl.formatMessage({id: 'STORE.DETAIL.SUBSCRIPTIONS.EXPIRY_DATE'}),
      render: (text: string) => <>{getDateAndTime(text)}</>,
    },
    // {
    //   key: 'LastInvoiceDate',
    //   dataIndex: 'lastInvoiceDate',
    //   title: intl.formatMessage({id: 'STORE.DETAIL.SUBSCRIPTIONS.LAST_INVOICE_DATE'}),
    //   render: (text: string) => <>{getDateAndTime(text)}</>,
    // },
    // {
    //   key: 'CardOnFile',
    //   dataIndex: 'cardOnFile',
    //   title: intl.formatMessage({id: 'STORE.DETAIL.SUBSCRIPTIONS.CARD_ON_FILE'}),
    //   yesOrNo: true,
    // },
  ]

  return (
    <div className='card mb-5 mb-xl-10' id='kt_profile_details_view'>
      <div className='card-header'>
        <div className='card-title m-0'>
          <div>
            <h3 className='fw-bold mb-2 mt-5'>
              {intl.formatMessage({id: 'STORE.DETAIL.SUBSCRIPTIONS'})}
            </h3>
            <p className='fw-normal fs-6'>
              {intl.formatMessage({id: 'STORE.DETAIL.SUBSCRIPTIONS_TOOLTIP'})}
            </p>
          </div>
        </div>
      </div>

      <div className='card-body pt-0'>
        <div className='table-responsive'>
          <Table
            loading={loading}
            dataSource={data}
            columns={Columns}
            pagination={{
              current: paging.currentPageNumber,
              pageSize: paging.pageSize,
              total: paging.totalCount,
              onChange: (page: any) => {
                if (!detail || !detail.Subscription) return
                const {pageSize, current} = page
                const currentPage = pageSize !== detail.Subscription.paging.pageSize ? 1 : current

                detailSet({
                  ...detail,
                  Subscription: {
                    ...detail.Subscription,
                    paging: {
                      ...paging,
                      currentPageNumber: currentPage,
                      pageSize: pageSize,
                    },
                  },
                })

                tabFilterSet({
                  ...tabFilter,
                  paging: {
                    currentPageNumber: currentPage,
                    pageSize: pageSize,
                  },
                })
              },
            }}
          />
        </div>
      </div>
    </div>
  )
}

export default StoreSubscriptions
